import React from 'react';
import { CheckIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import useShouldRenderOnsiteNotifications from '../../hooks/useShouldRenderOnsiteNotifications';

/**
 * Component that renders  if a caller ID's location lands inside of a connected
 * building if user has access to the feature
 * @param {String} callerId - caller ID
 */
const OnsitePersonnelBanner = ({ callerId }) => {
  const shouldRenderOnsiteNotifications =
    useShouldRenderOnsiteNotifications(callerId);

  if (!shouldRenderOnsiteNotifications) {
    return null;
  }

  return (
    <Box p="16px" width="100%">
      <Box p="16px" bg="success" borderRadius="5px">
        <Box horizontal align="center">
          <CheckIcon color="background" />
          <Box pl="16px">
            <Text fontWeight="bold" size="normal" color="background">
              Onsite Personnel Notified
            </Text>
            <Text size="normal" color="background">
              Call location shared w/ onsite personnel
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default React.memo(OnsitePersonnelBanner);
